export { useEditorStyles } from './useEditorStyles'
